import $ from 'jquery';
import   {
  numberFieldFormatsHandler,
  textFieldFormatsHandler,
  attachFieldFormatsHandler,
  phoneFieldFormatsHandler,
  checkboxSelectFieldFormatsHandler,
  sectionFieldFormatsHandler,
  tableFieldFormatsHandler,
  removeCustomFieldHandler,
  removeNewCustomFieldHandler,
  removeFieldVariantHandler
} from './custom-fields';
import {addFieldVariantHandler} from './add-custom-fields-variants';
import {initWorkContentWysiwyg, initWysiwyg} from './wysiwyg';
import {initCustomRegionFieldSelect} from "./custom-region-field-select";
import {showFormResponse} from "../common/json-response";
import {initAnyFileUpload} from '../cabinet/upload';
import {showDependsParams} from '../cabinet/show-custom-fields-params';
import initAddNewCustomFieldsColumn  from '../cabinet/add-custom-fields-column';
import {initAddNewCustomColumnVariants}  from '../cabinet/add-custom-column-variants';
import {initDeleteCustomColumnVariants}  from '../cabinet/delete-custom-column-variants';
import {initDeleteCustomColumn}  from '../cabinet/delete-custom-column';
import {initContestCustomFieldsColumns} from '../cabinet/custom-fields-columns';
import {initAiTextFieldPromptTest} from './ai-text-field-prompt-test';

function initCustomField(customFieldBlock) {
  const numberFieldFormat = customFieldBlock.querySelector('.custom_field_format[data-custom-field-format="1"]');
  numberFieldFormat.addEventListener('change', numberFieldFormatsHandler);

  const textFieldFormat = customFieldBlock.querySelector('.custom_field_format[data-custom-field-format="2"]');
  textFieldFormat.addEventListener('change', textFieldFormatsHandler);

  const attachFieldFormat = customFieldBlock.querySelector('.custom_field_format[data-custom-field-format="3"]');
  attachFieldFormat.addEventListener('change', attachFieldFormatsHandler);

  const phoneFieldFormat = customFieldBlock.querySelector('.custom_field_format[data-custom-field-format="4"]');
  phoneFieldFormat.addEventListener('change', phoneFieldFormatsHandler);

  const checkboxFieldFormat = customFieldBlock.querySelector('.custom_field_format[data-custom-field-format="5"]');
  checkboxFieldFormat.addEventListener('change', checkboxSelectFieldFormatsHandler);

  const selectFieldFormat = customFieldBlock.querySelector('.custom_field_format[data-custom-field-format="6"]');
  selectFieldFormat.addEventListener('change', checkboxSelectFieldFormatsHandler);

  const sectionFieldFormat = customFieldBlock.querySelector('.custom_field_format[data-custom-field-format="7"]');
  sectionFieldFormat.addEventListener('change', sectionFieldFormatsHandler);

  const regionFieldFormat = customFieldBlock.querySelector('.custom_field_format[data-custom-field-format="8"]');
  regionFieldFormat.addEventListener('change', checkboxSelectFieldFormatsHandler);

  const radioFieldFormat = customFieldBlock.querySelector('.custom_field_format[data-custom-field-format="9"]');
  radioFieldFormat.addEventListener('change', checkboxSelectFieldFormatsHandler);

  const rangeNumberFieldFormat = customFieldBlock.querySelector('.custom_field_format[data-custom-field-format="10"]');
  rangeNumberFieldFormat.addEventListener('change', checkboxSelectFieldFormatsHandler);

  const tableFieldFormat = customFieldBlock.querySelector('.custom_field_format[data-custom-field-format="11"]');
  tableFieldFormat.addEventListener('change', tableFieldFormatsHandler);

  const aiTextFieldFormat = customFieldBlock.querySelector('.custom_field_format[data-custom-field-format="13"]');
  aiTextFieldFormat?.addEventListener('change', textFieldFormatsHandler);

  // удаление заполненных, но не сохраненных настраиваемых полей
  const removeNewCustomFieldButton = customFieldBlock.querySelector('.delete_filled_custom_field');
  removeNewCustomFieldButton.addEventListener('click', removeNewCustomFieldHandler);

  // Удаление сохраненных вариантов настраиваемых полей с типом checkbox, select
  const addFieldVariantButton = customFieldBlock.querySelector('.add_field_variant');
  addFieldVariantButton?.addEventListener('click', addFieldVariantHandler);

  const removeFieldVariantButtons = customFieldBlock.querySelectorAll('.delete_custom_field_variant');
  removeFieldVariantButtons?.forEach(function (button) {
    button.addEventListener('click', removeFieldVariantHandler);
  });

  const addCheckboxSelectFieldVariants = customFieldBlock.querySelectorAll('.add_field_variant');

  addCheckboxSelectFieldVariants?.forEach(function (button) {
    button.addEventListener('click', addFieldVariantHandler);
  });
}

export default function() {
  const customFieldsBlock = document.querySelector('.custom_fields_block');
  const addCustomFieldBtn = document.querySelector('.btn[name="addCustomField"]');
  addCustomFieldBtn?.addEventListener('click', function (e) {
    e.preventDefault();
    const statusWrapper = document.querySelector('.action-status-messages');

    $.ajax({
      type: "GET",
      url: addCustomFieldBtn.getAttribute('data-add-custom-field-url'),
      dataType: 'json',
      success: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else if (data.html) {
          customFieldsBlock.insertAdjacentHTML('beforeEnd', data.html);
          const customFieldBlock = customFieldsBlock.querySelector('.custom_field_block:last-child');
          initCustomField(customFieldBlock);

          initAddNewCustomFieldsColumn();
          initAddNewCustomColumnVariants();
          initDeleteCustomColumnVariants();
          initDeleteCustomColumn();
          initContestCustomFieldsColumns();
          initWorkContentWysiwyg();
          initWysiwyg();
          initCustomRegionFieldSelect();
          initAnyFileUpload();
          showDependsParams();
          initAiTextFieldPromptTest(customFieldBlock);
        }
      },
      error: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else {
          const message = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
          const statusMsg = document.createElement('div');
          statusMsg.classList.add(['alert']);
          statusMsg.classList.add(['alert_error']);
          statusMsg.innerHTML = message;
          statusWrapper.appendChild(statusMsg);
        }
      },
    });
  });
}